// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1ab0ee76","479":"f4972b56"}[chunkId] + ".chunk.js";
};